// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2Fmt1","label":"Labeled_label__3m-mO","divider":"Labeled_divider__3zgtC"};